import React, { useCallback, useMemo } from 'react'

const CustomAnchor = ({ children, onClick, href, target, disabled = false, className, ...otherProps }) => {

    const anchorClass = useMemo(() => `bimmatch-anchor-tag ${disabled ? 'bimmatch-anchor-disabled' : 'bimmatch-anchor-normal'} ${className}`, [disabled, className])

    const handleClick = useCallback(() => {
        if (onClick) {
            onClick()
        }
    }, [onClick])

    return (
        <>
            {!!href ? <a dir="auto" className={anchorClass} href={href} target={target} {...otherProps}>{children}</a> : <span dir="auto" className={anchorClass} onClick={handleClick} {...otherProps}>{children}</span>}
        </>
    )
}

export default CustomAnchor